import type { App } from 'vue'
import avatar from '@/assets/avatar.png'
const sId = 'liyao-userselect-none'
import Exposure from './exposure'
import Click from './click'
// 实例化曝光和点击
const exp = new Exposure()
const cli = new Click()

const install = (app: App<Element>) => {
  app.directive('longpress', {
    mounted(el: Element, binding: any) {
      if (typeof binding.value !== 'function') {
        console.warn('长按事件参数必须为函数类型')
        return false
      }

      el.instance = el.instance || {}
      // 支持自定义传入长按响应时间
      const PRESS_TIME = binding.arg * 1 || 520 // 长按时间
      let startTime = 0

      let pressTimer: number
      const start = (ev: Event): void => {
        startTime = Date.now()

        console.log('touchstart')
        cancel()
        pressTimer = window.setTimeout(() => {
          //alert(binding.instance.bShow)
          //alert('run')
          handler(ev)
        }, PRESS_TIME)
      }
      const cancel = (): void => {
        clearTimeout(pressTimer)
      }
      const handler = (ev: Event): void => {
        if (!document.getElementById(sId)) {
          const oStyle = document.createElement('style')
          oStyle.id = sId
          document.head.appendChild(oStyle)

          // 添加 CSS 规则
          const rule = `
          * {
            -webkit-touch-callout:none;  
            -webkit-user-select:none;  
            -khtml-user-select:none;  
            -moz-user-select:none;  
            -ms-user-select:none;  
            user-select:none;
          }`
          oStyle.sheet?.insertRule(rule, oStyle.sheet.cssRules.length)
        }

        binding.value(ev, binding.arg)
      }

      const touchend = (ev: Event) => {
        console.log('touch' + ev.type, Date.now() - startTime, PRESS_TIME)

        if (Date.now() - startTime >= PRESS_TIME) {
          //alert(ev.type)
          ev.preventDefault()
        }
        cancel()
      }

      el.instance.start = start
      el.instance.cancel = cancel
      el.instance.touchend = touchend
      el.instance.touchcancel = touchend

      el.addEventListener('touchstart', start)
      el.addEventListener('touchend', touchend)
      el.addEventListener('touchmove', cancel)
      el.addEventListener('touchcancel', touchend)
    },
    beforeUnmount(el: Element) {
      const oStyle = document.getElementById(sId)
      if (oStyle) {
        oStyle.remove()
      }
      if (el.instance.start) {
        el.removeEventListener('touchstart', el.instance.start)
        el.removeEventListener('touchmove', el.instance.cancel)
        el.removeEventListener('touchcancel', el.instance.touchend)
        el.removeEventListener('touchend', el.instance.touchend)
        el.instance = null
      }
    },
  })
  app.directive('avatar', {
    mounted(el: Element | any, binding: any) {
      el.iCountError = 0
      if (binding.value) {
        el.setAttribute('src', binding.value)
      } else {
        el.setAttribute('src', avatar)
      }
      // 头像加载失败
      el.onerror = () => {
        el.iCountError = el.iCountError + 1
        if (el.iCountError > 5) {
          return
        }
        el.setAttribute('src', avatar)
      }
    },
    updated(el: Element | any, binding: any) {
      if (binding.value) {
        el.setAttribute('src', binding.value)
      } else {
        el.setAttribute('src', avatar)
      }
      // 头像加载失败
      el.onerror = () => {
        el.iCountError = el.iCountError + 1
        if (el.iCountError > 5) {
          return
        }
        el.setAttribute('src', avatar)
      }
    },
  })

  /*
  * 页面使用自定义指令完成上报
    // 点击事件
    <div v-track:click></div>

    // 点击事件带参数
    <div v-track:click :track-params="12455"></div>

    // 曝光事件
    <div v-track:exposure></div>

    // 曝光事件带参数
    <div v-track:exposure :track-params="12455"></div>

    // 曝光事件并点击带参数
    <div v-track:click|exposure :track-params="12455"></div>
  *
  * */

  app.directive('track', {
    mounted(el: Element | any, binding) {
      // 获取指令参数
      const { arg } = binding
      arg?.split('|').forEach((item) => {
        // 点击
        if (item === 'click') {
          cli.add({ el })
        } else if (item === 'exposure') {
          exp.add({ el })
        }
      })
    },
  })
}

export default install
